// eslint-disable-next-line import/no-default-export
export default {
  assets: [],
  ddd: 0,
  fr: 60,
  h: 80,
  ip: 0,
  layers: [
    {
      ao: 0,
      bm: 0,
      ddd: 0,
      ind: 1,
      ip: 0,
      ks: {
        a: { a: 0, ix: 1, k: [0, 0, 0] },
        o: { a: 0, ix: 11, k: 0 },
        p: { a: 0, ix: 2, k: [40, 39.992, 0] },
        r: {
          a: 1,
          ix: 10,
          k: [
            {
              i: { x: [0.833], y: [0.833] },
              o: { x: [0.167], y: [0.167] },
              s: [0],
              t: 0,
            },
            { s: [728], t: 118 },
          ],
        },
        s: { a: 0, ix: 6, k: [24, 24, 100] },
      },
      nm: 'Null 62',
      op: 120,
      sr: 1,
      st: 0,
      ty: 3,
    },
    {
      ao: 0,
      bm: 0,
      ddd: 0,
      ind: 2,
      ip: 0,
      ks: {
        a: { a: 0, ix: 1, k: [0, 0, 0] },
        o: { a: 0, ix: 11, k: 100 },
        p: { a: 0, ix: 2, k: [0, 0, 0] },
        r: { a: 0, ix: 10, k: 0 },
        s: { a: 0, ix: 6, k: [100, 100, 100] },
      },
      nm: 'RadialLine',
      op: 120,
      parent: 1,
      shapes: [
        {
          bm: 0,
          cix: 2,
          hd: false,
          it: [
            {
              hd: false,
              ind: 0,
              ix: 1,
              ks: {
                a: 0,
                ix: 2,
                k: {
                  c: true,
                  i: [
                    [-55.228, 0],
                    [0, -55.228],
                    [55.228, 0],
                    [0, 55.228],
                  ],
                  o: [
                    [55.228, 0],
                    [0, 55.228],
                    [-55.228, 0],
                    [0, -55.228],
                  ],
                  v: [
                    [0, -100],
                    [100, 0],
                    [0, 100],
                    [-100, 0],
                  ],
                },
              },
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ty: 'sh',
            },
            {
              bm: 0,
              c: { a: 0, ix: 3, k: [1, 1, 1, 1] },
              hd: false,
              lc: 1,
              lj: 1,
              ml: 4,
              mn: 'ADBE Vector Graphic - Stroke',
              nm: 'Stroke 1',
              o: { a: 0, ix: 4, k: 100 },
              ty: 'st',
              w: { a: 0, ix: 5, k: 17 },
            },
            {
              a: { a: 0, ix: 1, k: [0, 0] },
              nm: 'Transform',
              o: { a: 0, ix: 7, k: 100 },
              p: { a: 0, ix: 2, k: [0, 0] },
              r: { a: 0, ix: 6, k: 0 },
              s: { a: 0, ix: 3, k: [100, 100] },
              sa: { a: 0, ix: 5, k: 0 },
              sk: { a: 0, ix: 4, k: 0 },
              ty: 'tr',
            },
          ],
          ix: 1,
          mn: 'ADBE Vector Group',
          nm: 'Ellipse 1',
          np: 3,
          ty: 'gr',
        },
        {
          e: {
            a: 1,
            ix: 2,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.33], y: [0] },
                s: [5],
                t: 0,
              },
              { s: [100], t: 75 },
            ],
          },
          hd: false,
          ix: 2,
          m: 1,
          mn: 'ADBE Vector Filter - Trim',
          nm: 'Trim Paths 1',
          o: { a: 0, ix: 3, k: 0 },
          s: {
            a: 1,
            ix: 1,
            k: [
              {
                i: { x: [0], y: [1] },
                o: { x: [0.33], y: [0] },
                s: [0],
                t: 45,
              },
              { s: [95], t: 119 },
            ],
          },
          ty: 'tm',
        },
      ],
      sr: 1,
      st: 13,
      ty: 4,
    },
    {
      ao: 0,
      bm: 0,
      ddd: 0,
      ind: 3,
      ip: 0,
      ks: {
        a: { a: 0, ix: 1, k: [40, 40, 0] },
        o: { a: 0, ix: 11, k: 20 },
        p: { a: 0, ix: 2, k: [40, 40, 0] },
        r: { a: 0, ix: 10, k: 0 },
        s: { a: 0, ix: 6, k: [100, 100, 100] },
      },
      nm: 'Box',
      op: 120,
      shapes: [
        {
          bm: 0,
          cix: 2,
          hd: false,
          it: [
            {
              hd: false,
              ind: 0,
              ix: 1,
              ks: {
                a: 0,
                ix: 2,
                k: {
                  c: true,
                  i: [
                    [0, 0],
                    [-4.418, 0],
                    [0, 0],
                    [0, -4.418],
                    [0, 0],
                    [4.418, 0],
                    [0, 0],
                    [0, 4.418],
                  ],
                  o: [
                    [0, -4.418],
                    [0, 0],
                    [4.418, 0],
                    [0, 0],
                    [0, 4.418],
                    [0, 0],
                    [-4.418, 0],
                    [0, 0],
                  ],
                  v: [
                    [-40, -32],
                    [-32, -40],
                    [32, -40],
                    [40, -32],
                    [40, 32],
                    [32, 40],
                    [-32, 40],
                    [-40, 32],
                  ],
                },
              },
              mn: 'ADBE Vector Shape - Group',
              nm: 'Path 1',
              ty: 'sh',
            },
            {
              bm: 0,
              c: { a: 0, ix: 4, k: [1, 0.999998863071, 1, 1] },
              hd: false,
              mn: 'ADBE Vector Graphic - Fill',
              nm: 'Fill 1',
              o: { a: 0, ix: 5, k: 100 },
              r: 1,
              ty: 'fl',
            },
            {
              a: { a: 0, ix: 1, k: [0, 0] },
              nm: 'Transform',
              o: { a: 0, ix: 7, k: 100 },
              p: { a: 0, ix: 2, k: [40, 40] },
              r: { a: 0, ix: 6, k: 0 },
              s: { a: 0, ix: 3, k: [100, 100] },
              sa: { a: 0, ix: 5, k: 0 },
              sk: { a: 0, ix: 4, k: 0 },
              ty: 'tr',
            },
          ],
          ix: 1,
          mn: 'ADBE Vector Group',
          nm: 'Group 2',
          np: 2,
          ty: 'gr',
        },
      ],
      sr: 1,
      st: 0,
      ty: 4,
    },
  ],
  markers: [],
  meta: { a: '', d: '', g: 'LottieFiles AE ', k: '', tc: '' },
  nm: 'OverlaySpinner_80px ',
  op: 120,
  v: '4.8.0',
  w: 80,
}
